
import { TableBody, TableCell, TableRow } from "@/components/ui/table";

export function ListingsEmptyState() {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={9} className="h-24 text-center">
          <p className="text-muted-foreground">No listings found matching your criteria</p>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
